import { useContext, useEffect } from "react";
import { BackButton } from "../../components/BackButton";
import ButtonSelect, { StringStringOption } from "../../components/ButtonSelect";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { saveStateRemote } from "../../utils/api";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";


const MaritalStatusStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Maritalstatus' } });
    dispatch({ type: 'set_step', step: Step.Maritalstatus });
    scrollToTopOfContent();
    
    const saveState = async () => { await saveStateRemote(state); }
    saveState();
  }, []);

  const maritalStatusOptions: StringStringOption[] = [
    { value: 'SINGLE', label: 'Alene' },
    { value: 'MARRIED', label: 'Gift' },
    { value: 'COHABITING', label: 'Samlevende' },
    { value: 'DIVORCED', label: 'Skilt' },
    { value: 'SEPERATED', label: 'Separeret' },
    { value: 'WIDOW', label: 'Enke/enkemand' },
  ];

  const onOptionSelected = (option: StringStringOption) => {
    dispatch({type: 'set_maritalStatus', values: option.value });
    navigate('/boern');
  };

  return (
    <>
      <h2>Hvad er din nuværende civilstatus?</h2>

      <div className="mt-5">
        <ButtonSelect
          options={maritalStatusOptions}
          onOptionSelected={(option) => onOptionSelected(option)}
          option={undefined}
          getOptionText={(option) => {
            return option.label;
          }}
          getOptionKey={(option) => {
            return option.value;
          }}
        ></ButtonSelect>
      </div>
      <div className="container-btn">
        <BackButton />
      </div>
    </>
  );
};

export default MaritalStatusStep;
